import { profile } from 'api';


export function getSessionToken(sessionToken) {
  return profile.get(`sessiontoken/${sessionToken}`).then((r) => r);
}